import { SVGProps } from 'react';
const SvgArrowDownLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 3v18M17 16l-5 5-5-5"
    />
  </svg>
);
export default SvgArrowDownLg;
